<!--
 * @Descripttion: 
 * @version: 
 * @Author: Francis
 * @Date: 2022-07-26 22:33:18
 * @LastEditors: Francis
 * @LastEditTime: 2022-07-27 01:39:17
-->
<template>
  <div class="accountant-business">
    <Header
      menuName="palletBusiness"
      :keyWord.sync="keyWord"
      pageName="业务中标"
      :component.sync="component"
    ></Header>
    <Footer :page="0"></Footer>
    <!-- <components :is=""></components> -->
    <BidFail
      :keyWord.sync="keyWord"
      v-if="component === 'bidFail'"
      class="bidFail component"
    ></BidFail>
    <BidWin
      :keyWord.sync="keyWord"
      v-if="component === 'bidWin'"
      class="bidWin component"
    ></BidWin>
  </div>
</template>

<script>
import Footer from "@/components/Footer";
import Header from "@/components/Header";
import BidFail from "./components/BidFail";
import BidWin from "./components/BidWin";
export default {
  name: "accountantBusiness",
  components: {
    Footer,
    Header,
    BidFail,
    BidWin,
  },
  props: {},
  data() {
    return {
      keyWord: "",
      component: "",
    };
  },
  computed: {},
  watch: {},
  created() {
  
  },
  mounted() {},
  methods: {
  
  },
};
</script>

<style lang="less" scoped>
.accountant-business {
  padding-top: 220px;
  padding-bottom: 70px;
}
</style>
